<template lang="pug">
el-date-picker(
  size="mini" type="daterange" prefix-icon="circular" :style="{width: w ? w + 'px' : '100%'}"
  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
  v-model="timeVal" value-format="yyyy-MM-dd" :default-value="defaultValue" :picker-options="pickerOptions"
)
</template>

<script>
class baseTodayDay {
  constructor (date, mode) {
    this._date = date
    this._mode = mode
    this._now = new Date()
    this._targetDay = new Date(this._now.getFullYear(), this._now.getMonth(), this._now.getDate() + this._date)
  }

  get StrDay () {
    return this.FormatTime(this._targetDay, this._mode)
  }

  get DateDay () {
    return this._targetDay
  }

  // 时间戳时间
  get TimeDay () {
    return this._targetDay.getTime()
  }

  FormatTime (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
    if (!date) return
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  }
}

export default {
  name: 'DateTimeRange',
  props: {
    value: Array,
    w: '',
    defaultTime: '',
    disabledDateFn: Function
  },
  data () {
    let vm = this
    return {
      defaultValue: this.defaultTime || new Date(), // 展示
      pickerOptions: {
        disabledDate (time) { // 禁选时间段方法处理
          if (vm.disabledDateFn) return vm.disabledDateFn(time)
          return false
        }
      }
    }
  },
  computed: {
    timeVal: {
      set (nv) {
        this.$emit('input', nv)
      },
      get () {
        return this.value
      }
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor {
  ::v-deep .el-range-input {
    min-width: 65px;
  }
  ::v-deep .el-range-separator {
    min-width: 20px;
    padding: 0;
  }
  &.el-range-editor--mini {
    .el-range__close-icon, .el-range__icon {

    }
  }
}
</style>
